import styled from 'styled-components';

const containerPadding = '16px';

export const WidgetSection = styled.section`
  display: grid;
  grid-template-areas:
    'Header Header'
    'Content Content'
    'Footer Footer';
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr auto;
`;

export const Header = styled.header`
  grid-area: Header;
  padding-bottom: 20px;
`;

export const Footer = styled.footer`
  grid-area: Footer;
  padding-left: ${containerPadding};
`;

export const Content = styled.div`
  grid-area: Content;
  position: relative;
  width: auto;
  min-height: 200px;
`;
